import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';
import { markLanguageChosen } from '../utils/languageChoice';

/**
 * Two-pill segmented control for switching between EN and SQ.
 *
 * Earlier versions used flag glyphs (🇬🇧 / 🇦🇱). Those render
 * inconsistently across platforms (Windows ships them as letter
 * pairs `GB`/`AL`, macOS as actual flags) which created an uneven
 * visual treatment depending on the visitor's OS. Plain text
 * `EN` / `SQ` reads cleanly on every platform and matches the
 * minimal-premium register set in Phase 1A.
 */
const LANGUAGES = [
  { code: 'en', label: 'EN', titleKey: 'nav.english' },
  { code: 'sq', label: 'SQ', titleKey: 'nav.albanian' },
];

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const active = (i18n.language || 'en').toLowerCase().startsWith('sq') ? 'sq' : 'en';

  return (
    <div
      className="language-switcher"
      role="group"
      aria-label={t('nav.languageSwitcher', 'Language')}
    >
      {LANGUAGES.map(({ code, label, titleKey }) => (
        <button
          key={code}
          type="button"
          className={`lang-btn ${active === code ? 'active' : ''}`}
          onClick={() => { markLanguageChosen(); i18n.changeLanguage(code); }}
          aria-pressed={active === code}
          title={t(titleKey, code === 'en' ? 'English' : 'Shqip')}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
